import { List } from 'immutable';

export default List();



// WEBPACK FOOTER //
// ./src/models/EmptyList.js